// extracted by mini-css-extract-plugin
export var conversationListItem = "_yk-2";
export var fullBleedList = "_yk-3";
export var messageText = "_yk-1";
export var previewText = "_yk-0";